import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/paginated/transaction.model';
import { ColumnDef, createColumnHelper } from '@tanstack/react-table';

import { TokenTransactionListChargePointColumn } from './token-transaction-list-charge-point.column';
import { TokenTransactionListDurationColumn } from './token-transaction-list-duration.column';
import { TokenTransactionListKwhColumn } from './token-transaction-list-kwh.column';
import { TokenTransactionListLocationColumn } from './token-transaction-list-location.column';
import { TokenTransactionListOcpiSessionIdColumn } from './token-transaction-list-ocpi-session-id.column';
import { TokenTransactionListStartedAtColumn } from './token-transaction-list-started-at.column';
import { TokenTransactionListStateColumn } from './token-transaction-list-state.column';
import { TokenTransactionListStoppedAtColumn } from './token-transaction-list-stopped-at.column';
import { TokenTransactionListTotalCostColumn } from './token-transaction-list-total-cost.column';

// /////////////////////////////////////////////////////////////////////////////
// DISPLAYING
// /////////////////////////////////////////////////////////////////////////////

export const tokenTransactionListColumnHelper =
  createColumnHelper<TransactionModel>();

type ResourceColumnType = ColumnDef<TransactionModel, any>[];

export const TOKEN_TRANSACTION_LIST_COLUMN_LIST: ResourceColumnType = [
  tokenTransactionListColumnHelper.accessor(
    'ocpiSessionId',
    TokenTransactionListOcpiSessionIdColumn,
  ),
  tokenTransactionListColumnHelper.accessor(
    'location',
    TokenTransactionListLocationColumn,
  ),
  tokenTransactionListColumnHelper.accessor(
    'chargePoint',
    TokenTransactionListChargePointColumn,
  ),
  tokenTransactionListColumnHelper.accessor(
    'startedAt',
    TokenTransactionListStartedAtColumn,
  ),
  tokenTransactionListColumnHelper.display(TokenTransactionListDurationColumn),
  tokenTransactionListColumnHelper.accessor(
    'stoppedAt',
    TokenTransactionListStoppedAtColumn,
  ),
  tokenTransactionListColumnHelper.accessor(
    'state',
    TokenTransactionListStateColumn,
  ),
  tokenTransactionListColumnHelper.accessor(
    'kwh',
    TokenTransactionListKwhColumn,
  ),
  tokenTransactionListColumnHelper.accessor(
    'totalCost',
    TokenTransactionListTotalCostColumn,
  ),
];

export const TOKEN_TRANSACTION_LIST_COLUMN_ID_LIST =
  TOKEN_TRANSACTION_LIST_COLUMN_LIST.flatMap((columnDef) => {
    if ('accessorKey' in columnDef) {
      return [columnDef.id ?? (columnDef.accessorKey as string)];
    }

    if (columnDef.id) {
      return [columnDef.id];
    }

    return [];
  });

export const TOKEN_TRANSACTION_LIST_COLUMN_ORDER = [
  ...TOKEN_TRANSACTION_LIST_COLUMN_ID_LIST,
];

export const TOKEN_TRANSACTION_LIST_COLUMN_VISIBILITY =
  TOKEN_TRANSACTION_LIST_COLUMN_ID_LIST.reduce((columnVisibility, columnId) => {
    return { ...columnVisibility, [columnId]: true };
  }, {});
